module.exports = MODESIGN;